import { Editor } from "slate";
import { ElementUtils } from "../utils/element";
import { getSelection } from "../selectors";
import { responsiveShallowEqual } from "../utils/responsive";
function getValue(editor) {
  const matchingValues = Array.from(
    Editor.nodes(editor, {
      at: getSelection(editor),
      match: ElementUtils.isRootBlock
    })
  ).map(([node]) => node["textAlign"]);
  return matchingValues.length === 0 ? void 0 : matchingValues.reduce((a, b) => {
    return responsiveShallowEqual(a, b);
  });
}
export {
  getValue
};
//# sourceMappingURL=getValue.js.map